<template>
  <div class="pt-10 pb-5 bg-white-light h-screen">
    <div class="pb-20">
      <Sidebar></Sidebar>
      <Header>{{ familiare.name }} {{ familiare.surname }}</Header>
      <div class="bg-pink pb-8 pt-8 px-10 text-center block">
        <div class="flex items-baseline">
          <div class="relative flex-1">
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative "
              src="/img/user.png"
            >
          </div>
        </div>
      </div>
      <div class="container mx-auto">
        <div class="px-4 pt-5">
          <p class="text-blue-dark">
            {{$t('all.profile_data')}}
          </p>
          <div class="flex">
            <div class="pt-4 flex-1">
              <p class="pb-2">
                <i class="text-xs">{{$t('all.common_name')}}</i><br>
                {{ familiare.name }}
              </p>
            </div>
            <div class="pt-4 flex-1">
              <p class="pb-2">
                <i class="text-xs">{{$t('all.common_last_name')}}</i><br>
                {{ familiare.surname }}
              </p>
            </div>
          </div>
          <div class="pt-4">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
              {{ familiare.fiscal_code }}
            </p>
          </div>
          <div class="pt-4">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.profile_mobile')}}</i><br>
              {{ familiare.mobile }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id', 'genitore'],
  created() {
    this.getFamiliariMinore(this);
  },
  computed: {
    ...mapGetters({
      familiareSelected: 'familiari/familiare',
    }),
    familiare() {
      return this.familiareSelected(this.genitore);
    }
  },
  methods: {
    ...mapActions('familiari', ['getFamiliariMinore']),
  },
};
</script>
